// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CategoryRankingPage.css - 카테고리 순위 관리 페이지 전용 스타일 */

.admin-content-ranking {
    flex-grow: 1;
    padding: 30px;
    background-color: #f8f9fa;
}

.crp-page-header {
    margin-bottom: 30px;
    padding: 20px 0;
    border-bottom: 2px solid #dee2e6;
}

.crp-page-header h2 {
    color: #212529;
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 8px;
}

.crp-page-header p {
    color: #6c757d;
    font-size: 1rem;
    margin: 0;
}

.crp-category-ranking-container {
    background: white;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
}

.crp-form-row {
    margin-bottom: 30px;
}

.crp-form-row label {
    display: block;
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
    font-size: 1rem;
}

.crp-main-category-select {
    width: 100%;
    max-width: 400px;
    padding: 12px 16px;
    border: 2px solid #dee2e6;
    border-radius: 8px;
    font-size: 1rem;
    background-color: white;
    transition: border-color 0.3s ease;
}

.crp-main-category-select:focus {
    outline: none;
    border-color: #E84100;
    box-shadow: 0 0 0 3px rgba(232, 65, 0, 0.1);
}

.crp-ranking-interface {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    margin-top: 30px;
}

.crp-category-list-section {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 20px;
}

.crp-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.crp-list-header h3 {
    color: #495057;
    font-size: 1.2rem;
    font-weight: 600;
    margin: 0;
}

.crp-btn-create {
    background-color: #E84100;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.crp-btn-create:hover {
    background-color: #d73502;
}

.crp-category-list-box {
    max-height: 400px;
    overflow-y: auto;
    background: white;
    border-radius: 6px;
    border: 1px solid #dee2e6;
}

.crp-list-box-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f1f3f4;
    cursor: pointer;
    transition: all 0.2s ease;
    gap: 10px;
}

.crp-list-box-item:last-child {
    border-bottom: none;
}

.crp-list-box-item:hover {
    background-color: #f8f9fa;
}

.crp-list-box-item.selected {
    background-color: #fff3e0;
    border-left: 4px solid #E84100;
}

.crp-drag-handle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    cursor: grab;
    color: #666;
    transition: color 0.2s ease;
}

.crp-drag-handle:hover {
    color: #333;
}

.crp-drag-handle:active {
    cursor: grabbing;
}

.crp-category-name {
    flex: 1 1;
    font-weight: 500;
    color: #495057;
}

.crp-item-actions {
    display: flex;
    gap: 8px;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.crp-list-box-item:hover .crp-item-actions {
    opacity: 1;
}

.crp-edit-btn,
.crp-delete-btn {
    padding: 4px 8px;
    border: none;
    border-radius: 4px;
    font-size: 0.8rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.crp-edit-btn {
    background-color: #28a745;
    color: white;
}

.crp-edit-btn:hover {
    background-color: #218838;
}

.crp-delete-btn {
    background-color: #dc3545;
    color: white;
}

.crp-delete-btn:hover {
    background-color: #c82333;
}

.crp-loading,
.crp-empty {
    text-align: center;
    padding: 40px 20px;
    color: #6c757d;
    font-style: italic;
}

.crp-category-details {
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 24px;
}

.crp-category-details h3 {
    color: #495057;
    font-size: 1.3rem;
    font-weight: 600;
    margin-bottom: 24px;
    padding-bottom: 12px;
    border-bottom: 1px solid #dee2e6;
}

.crp-form-group {
    margin-bottom: 20px;
}

.crp-form-group label {
    display: block;
    font-weight: 600;
    color: #495057;
    margin-bottom: 6px;
    font-size: 0.9rem;
}

.crp-form-group input,
.crp-form-group textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #ced4da;
    border-radius: 6px;
    font-size: 0.9rem;
    transition: border-color 0.3s ease;
    box-sizing: border-box;
}

.crp-form-group input:focus,
.crp-form-group textarea:focus {
    outline: none;
    border-color: #E84100;
    box-shadow: 0 0 0 2px rgba(232, 65, 0, 0.1);
}

.crp-form-group input:disabled,
.crp-form-group textarea:disabled {
    background-color: #f8f9fa;
    color: #6c757d;
    cursor: not-allowed;
}

.crp-form-group textarea {
    resize: vertical;
    min-height: 80px;
}

.crp-form-group-checkbox {
    margin-bottom: 24px;
}

.crp-form-group-checkbox label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    color: #495057;
    cursor: pointer;
}

.crp-form-group-checkbox input[type="checkbox"] {
    width: auto;
    margin: 0;
}

.crp-form-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #dee2e6;
}

.crp-btn-cancel,
.crp-btn-save {
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
}

.crp-btn-cancel {
    background-color: #6c757d;
    color: white;
}

.crp-btn-cancel:hover {
    background-color: #5a6268;
}

.crp-btn-save {
    background-color: #E84100;
    color: white;
}

.crp-btn-save:hover {
    background-color: #d73502;
}

.crp-bottom-actions {
    text-align: center;
}

.crp-btn-back {
    background-color: #6c757d;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 6px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.crp-btn-back:hover {
    background-color: #5a6268;
}

/* 반응형 디자인 */
@media (max-width: 1024px) {
    .crp-ranking-interface {
        grid-template-columns: 1fr;
        gap: 20px;
    }
}

@media (max-width: 768px) {
    .admin-content-ranking {
        padding: 15px;
    }
    
    .crp-category-ranking-container {
        padding: 20px;
    }
    
    .crp-page-header h2 {
        font-size: 1.5rem;
    }
    
    .crp-list-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
    
    .crp-btn-create {
        width: 100%;
    }
    
    .crp-item-actions {
        opacity: 1; /* 모바일에서는 항상 표시 */
    }
    
    .crp-form-actions {
        flex-direction: column;
    }
    
    .crp-btn-cancel,
    .crp-btn-save {
        width: 100%;
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/CategoryRankingPage.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,YAAY;AACZ;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU,EAAE,iBAAiB;IACjC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;AACJ","sourcesContent":["/* CategoryRankingPage.css - 카테고리 순위 관리 페이지 전용 스타일 */\n\n.admin-content-ranking {\n    flex-grow: 1;\n    padding: 30px;\n    background-color: #f8f9fa;\n}\n\n.crp-page-header {\n    margin-bottom: 30px;\n    padding: 20px 0;\n    border-bottom: 2px solid #dee2e6;\n}\n\n.crp-page-header h2 {\n    color: #212529;\n    font-size: 2rem;\n    font-weight: 700;\n    margin-bottom: 8px;\n}\n\n.crp-page-header p {\n    color: #6c757d;\n    font-size: 1rem;\n    margin: 0;\n}\n\n.crp-category-ranking-container {\n    background: white;\n    border-radius: 12px;\n    padding: 30px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    margin-bottom: 30px;\n}\n\n.crp-form-row {\n    margin-bottom: 30px;\n}\n\n.crp-form-row label {\n    display: block;\n    font-weight: 600;\n    color: #495057;\n    margin-bottom: 8px;\n    font-size: 1rem;\n}\n\n.crp-main-category-select {\n    width: 100%;\n    max-width: 400px;\n    padding: 12px 16px;\n    border: 2px solid #dee2e6;\n    border-radius: 8px;\n    font-size: 1rem;\n    background-color: white;\n    transition: border-color 0.3s ease;\n}\n\n.crp-main-category-select:focus {\n    outline: none;\n    border-color: #E84100;\n    box-shadow: 0 0 0 3px rgba(232, 65, 0, 0.1);\n}\n\n.crp-ranking-interface {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 30px;\n    margin-top: 30px;\n}\n\n.crp-category-list-section {\n    background: #f8f9fa;\n    border-radius: 8px;\n    padding: 20px;\n}\n\n.crp-list-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.crp-list-header h3 {\n    color: #495057;\n    font-size: 1.2rem;\n    font-weight: 600;\n    margin: 0;\n}\n\n.crp-btn-create {\n    background-color: #E84100;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 6px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.crp-btn-create:hover {\n    background-color: #d73502;\n}\n\n.crp-category-list-box {\n    max-height: 400px;\n    overflow-y: auto;\n    background: white;\n    border-radius: 6px;\n    border: 1px solid #dee2e6;\n}\n\n.crp-list-box-item {\n    display: flex;\n    align-items: center;\n    padding: 12px 16px;\n    border-bottom: 1px solid #f1f3f4;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    gap: 10px;\n}\n\n.crp-list-box-item:last-child {\n    border-bottom: none;\n}\n\n.crp-list-box-item:hover {\n    background-color: #f8f9fa;\n}\n\n.crp-list-box-item.selected {\n    background-color: #fff3e0;\n    border-left: 4px solid #E84100;\n}\n\n.crp-drag-handle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    cursor: grab;\n    color: #666;\n    transition: color 0.2s ease;\n}\n\n.crp-drag-handle:hover {\n    color: #333;\n}\n\n.crp-drag-handle:active {\n    cursor: grabbing;\n}\n\n.crp-category-name {\n    flex: 1;\n    font-weight: 500;\n    color: #495057;\n}\n\n.crp-item-actions {\n    display: flex;\n    gap: 8px;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n}\n\n.crp-list-box-item:hover .crp-item-actions {\n    opacity: 1;\n}\n\n.crp-edit-btn,\n.crp-delete-btn {\n    padding: 4px 8px;\n    border: none;\n    border-radius: 4px;\n    font-size: 0.8rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.crp-edit-btn {\n    background-color: #28a745;\n    color: white;\n}\n\n.crp-edit-btn:hover {\n    background-color: #218838;\n}\n\n.crp-delete-btn {\n    background-color: #dc3545;\n    color: white;\n}\n\n.crp-delete-btn:hover {\n    background-color: #c82333;\n}\n\n.crp-loading,\n.crp-empty {\n    text-align: center;\n    padding: 40px 20px;\n    color: #6c757d;\n    font-style: italic;\n}\n\n.crp-category-details {\n    background: white;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    padding: 24px;\n}\n\n.crp-category-details h3 {\n    color: #495057;\n    font-size: 1.3rem;\n    font-weight: 600;\n    margin-bottom: 24px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.crp-form-group {\n    margin-bottom: 20px;\n}\n\n.crp-form-group label {\n    display: block;\n    font-weight: 600;\n    color: #495057;\n    margin-bottom: 6px;\n    font-size: 0.9rem;\n}\n\n.crp-form-group input,\n.crp-form-group textarea {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid #ced4da;\n    border-radius: 6px;\n    font-size: 0.9rem;\n    transition: border-color 0.3s ease;\n    box-sizing: border-box;\n}\n\n.crp-form-group input:focus,\n.crp-form-group textarea:focus {\n    outline: none;\n    border-color: #E84100;\n    box-shadow: 0 0 0 2px rgba(232, 65, 0, 0.1);\n}\n\n.crp-form-group input:disabled,\n.crp-form-group textarea:disabled {\n    background-color: #f8f9fa;\n    color: #6c757d;\n    cursor: not-allowed;\n}\n\n.crp-form-group textarea {\n    resize: vertical;\n    min-height: 80px;\n}\n\n.crp-form-group-checkbox {\n    margin-bottom: 24px;\n}\n\n.crp-form-group-checkbox label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 500;\n    color: #495057;\n    cursor: pointer;\n}\n\n.crp-form-group-checkbox input[type=\"checkbox\"] {\n    width: auto;\n    margin: 0;\n}\n\n.crp-form-actions {\n    display: flex;\n    gap: 12px;\n    justify-content: flex-end;\n    margin-top: 24px;\n    padding-top: 20px;\n    border-top: 1px solid #dee2e6;\n}\n\n.crp-btn-cancel,\n.crp-btn-save {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 6px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.crp-btn-cancel {\n    background-color: #6c757d;\n    color: white;\n}\n\n.crp-btn-cancel:hover {\n    background-color: #5a6268;\n}\n\n.crp-btn-save {\n    background-color: #E84100;\n    color: white;\n}\n\n.crp-btn-save:hover {\n    background-color: #d73502;\n}\n\n.crp-bottom-actions {\n    text-align: center;\n}\n\n.crp-btn-back {\n    background-color: #6c757d;\n    color: white;\n    border: none;\n    padding: 12px 24px;\n    border-radius: 6px;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.crp-btn-back:hover {\n    background-color: #5a6268;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 1024px) {\n    .crp-ranking-interface {\n        grid-template-columns: 1fr;\n        gap: 20px;\n    }\n}\n\n@media (max-width: 768px) {\n    .admin-content-ranking {\n        padding: 15px;\n    }\n    \n    .crp-category-ranking-container {\n        padding: 20px;\n    }\n    \n    .crp-page-header h2 {\n        font-size: 1.5rem;\n    }\n    \n    .crp-list-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n    \n    .crp-btn-create {\n        width: 100%;\n    }\n    \n    .crp-item-actions {\n        opacity: 1; /* 모바일에서는 항상 표시 */\n    }\n    \n    .crp-form-actions {\n        flex-direction: column;\n    }\n    \n    .crp-btn-cancel,\n    .crp-btn-save {\n        width: 100%;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
